module.exports = __webpack_public_path__ + "img/mccord.69ae6fdf.jpg";